export interface WorkerTagOption {
  label: string;
  value: string;
}

/** Letters, digits, '.', '_' or '-', starting with a letter or digit, at most 64 characters. */
export const WORKER_TAG_NAME = /^[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/;

export function isWorkerTagName(raw: string | null | undefined): boolean {
  return WORKER_TAG_NAME.test((raw ?? '').trim());
}

/** Trims tokens, drops blanks, and collapses duplicates. Comparison is case-sensitive. */
export function normalizeWorkerTags(tags: readonly string[] | null | undefined): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const raw of tags ?? []) {
    const tag = raw.trim();
    if (tag.length === 0 || seen.has(tag)) {
      continue;
    }
    seen.add(tag);
    result.push(tag);
  }
  return result;
}

/** Catalog names first, then selected tokens that are no longer in the catalog. */
export function workerTagOptions(
  catalog: readonly string[],
  selected: readonly string[] = [],
): WorkerTagOption[] {
  return normalizeWorkerTags([...catalog, ...selected]).map(name => ({ label: name, value: name }));
}

/** Drops a selected token, or appends one that is not selected yet. */
export function toggleWorkerTag(selected: readonly string[], tag: string): string[] {
  const current = normalizeWorkerTags(selected);
  const token = tag.trim();
  if (token.length === 0) {
    return current;
  }
  if (current.includes(token)) {
    return current.filter(item => item !== token);
  }
  return [...current, token];
}

export function workerTagMatches(name: string, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (needle.length === 0) {
    return true;
  }
  return name.toLowerCase().includes(needle);
}
